import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import TimelineSection from './components/TimelineSection';
import CTASection from './components/CTASection';
import HomeSEO from './components/HomeSEO';

export default function Home() {
  return (
    <>
      <HomeSEO />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryCards />
        <FeaturedArticles />
        <TimelineSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}